import { createIcon } from './createIcon';

/**
 * Appearance — a circle half-filled, the standard light/dark mark. Reads as
 * "how this looks" at a glance, and stays legible at 16px where a paintbrush
 * or a droplet would not.
 */
export const AppearanceIcon = createIcon({
  name: 'AppearanceIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <circle cx="8" cy="8" r="5.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8 2.75a5.25 5.25 0 0 1 0 10.5V2.75Z" fill="currentColor" />
    </>
  ),
});

export default AppearanceIcon;
